import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';

export const StyledWrapper = styled(Flex)<{ left?: string }>`
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
`;

export const FilterContainer = styled.ul`
  position: relative;
  background: #ffffff;
`;

export const FilterContainerItem = styled.li<{ checked?: boolean }>`
  padding-left: 0;
  position: relative;
  height: 44px;
  padding: 0px;
  margin: 7px 0px;
  background: ${(props) => (props.checked ? '#ebebeb' : '#ffffff')};
  border-radius: 21px;
  padding-left: 5px;
`;

export const StyledFilterLabel = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  :hover input ~ .checkmark {
    background: #ebebeb;
    box-sizing: border-box;
    border-radius: 2px;
  }

  input:checked ~ .checkmark {
    background: #ebebeb;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }
`;

export const StyledFilterSpan = styled.span<{ hide?: boolean }>`
  opacity: ${(props) => (props.hide ? '0' : '1')};
  top: 13px;
  left: 26px;
  height: 20px;
  width: 20px;
  box-sizing: border-box;
  border-radius: 2px;
  position: absolute;
  background: #ebebeb;

  :after {
    content: '';
    position: absolute;
    display: none;

    left: 7px;
    top: 4px;
    width: 6px;
    height: 9px;
    border: solid #502080;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const StyledAccordionFilterText = styled(Text)<{ left?: string }>`
  font-size: 15px;
  line-height: 22px;
  padding: 12px;
  width: 100%;
  padding-left: ${(props) => props.left + 'px' || '0px'};
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  position: absolute;
  width: 15px;
  top: 16px;
  right: 30px;
`;

export const AccordionColorsContainer = styled.div`
  position: relative;
  width: 100%;
  background: #ffffff;
`;
